import { z } from 'zod';
import { hexColorSchema } from './tenancy.js';
// ------------------------------------------------------------ etiquetas (no contato)
export const tagSchema = z.object({ id: z.uuid(), name: z.string(), color: z.string() });
export const upsertTagSchema = z.object({
    name: z.string().trim().min(1, 'Dê um nome à etiqueta').max(40),
    color: hexColorSchema.transform((c) => c.toUpperCase()),
});
export const setContactTagsSchema = z.object({ tagIds: z.array(z.uuid()).max(20) });
// ------------------------------------------------------------ respostas rápidas
export const quickReplySchema = z.object({ id: z.uuid(), shortcut: z.string(), title: z.string(), body: z.string() });
export const upsertQuickReplySchema = z.object({
    shortcut: z.string().trim().toLowerCase().regex(/^[a-z0-9-]{2,30}$/, 'Atalho de 2 a 30 caracteres: letras minúsculas, números e hífen'),
    title: z.string().trim().min(2, 'Dê um título').max(80),
    body: z.string().trim().min(1, 'Escreva o texto').max(4096),
});
// ------------------------------------------------------------ distribuição automática de leads
export const leadDistributionSchema = z.object({
    enabled: z.boolean(),
    userIds: z.array(z.uuid()),
    /** quem recebe o próximo lead (null se desligada ou sem ninguém) */
    nextUserId: z.uuid().nullable(),
});
export const updateLeadDistributionSchema = z.object({ enabled: z.boolean(), userIds: z.array(z.uuid()).max(50) });
// ------------------------------------------------------------ transferência de conversa
export const transferConversationSchema = z.object({
    toUserId: z.uuid(),
    note: z.string().trim().max(500).optional(),
});
export const inboxAgentSchema = z.object({ id: z.uuid(), name: z.string(), isYou: z.boolean() });
//# sourceMappingURL=reception.js.map